import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from '../layout';

function Private({ component: Component, auth, ...rest }: any) {
  const { state: contactError } = useLocation();
  const token = useSelector((state: ApplicationState) => state.auth.token);
  const acceptedTerms = useSelector(
    (state: ApplicationState) => state.auth.user?.acceptedTerms
  );
  const terms = useSelector(
    (state: ApplicationState) => state.config.termosUso
  );
  const loading = useSelector((state: ApplicationState) => state.auth.loading);

  return (
    <>
      {loading && <></>}
      {!loading && (
        <Route
          {...rest}
          render={(props) =>
            token ? (
              acceptedTerms ? (
                <Layout>
                  <Component {...props} />
                </Layout>
              ) : terms ? (
                <Redirect to='/termos' />
              ) : (
                <Layout>
                  <Component {...props} />
                </Layout>
              )
            ) : contactError ? (
              <Layout>
                <Redirect to='/contato' />
              </Layout>
            ) : (
              <Redirect to='/' />
            )
          }
        />
      )}
    </>
  );
}

export default Private;
